import { useRxInternalField } from './hooks/useRxInternal';
import { DefaultProps, FormatProps } from './types';

export function useField(props: DefaultProps & FormatProps) {
    const {
        field,

        initialValue,

        mask,

        validate,
        validateOnChange,
        validateOnBlur,
        validateNotify,
        notify,

        onChange: consumerOnChange,
        onBlur: consumerOnBlur,
        onValueChange: consumerOnValueChange,
        ...rest
    } = props;
    const { onInputChange, onInputBlur, ref, getValueStream, formInitialValue } = useRxInternalField({
        field,
        consumerOnValueChange,
        consumerOnChange,
        consumerOnBlur,
        mask,
        validate,
        validateOnChange,
        validateOnBlur,
        validateNotify: validateNotify || notify,
        initialValue,
    });
    return {
        rest,
        onInputChange,
        onInputBlur,
        ref,
        formInitialValue,
        getValueStream,
    };
}
